import VueRouter from 'vue-router';
// Pages
import Home from './components/landing-pages/Home';
import Kontakt from './components/other-pages/contact/Kontakt.vue';

export const router = new VueRouter({
    mode: 'history',
    linkExactActiveClass: 'active',
    scrollBehavior() {
      return { x: 0, y: 0 };
    },
    routes: [
      { path: '/', component: Home },
      { path: '/kontakt', component: Kontakt },
    ]
});
